import React, { useEffect } from 'react'

import {
  BodyText,
  Button,
  HeadingLarge,
  Label,
  LayoutContainer as Container,
  Loader,
  ModalButtons,
} from '@pb/components'
import { LoadingStates } from '@pb/utils'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ConditionalRedirecter from 'App/ConditionalRedirecter'
import { ACCOUNT_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'

import {
  operationFetchStoreActivationSession,
  operationPerformStoreActivation,
} from '../../duck/operations'
import selectors from '../../duck/selectors'
import KlarnaPayment from '../KlarnaPayment'
import styles from './StoreActivation.scss'

const StoreActivation: React.FC<any> = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const isPayLaterAllowed = useSelector(appSelectors.getIsPayLaterActivationAllowed)
  const isPayLaterActivated = useSelector(appSelectors.getIsPayLaterActivatedForUser)
  const storeActivationSessionStatus = useSelector(selectors.getStoreActivationSessionStatus)
  const storeActivationSessionBody = useSelector(selectors.getStoreActivationSessionBody)
  const storeActivationPaymentMethodCategory = useSelector(
    selectors.getStoreActivationPaymentMethodCategory,
  )

  const storeActivationAuthInfo = useSelector((state) =>
    selectors.getPaymentMethodCategory(state, storeActivationPaymentMethodCategory),
  )
  const storeActivationAuthStatus = useSelector(selectors.getPaymentsAuthStatus)

  useEffect(() => {
    dispatch(operationFetchStoreActivationSession())
  }, [])

  const handleActivate = (): any => {
    dispatch(operationPerformStoreActivation())
  }

  const handleLeaveStoreActivation = (): any => {
    history.push(ACCOUNT_ROUTES.AccountOverview.path)
  }

  return (
    <ConditionalRedirecter
      shouldRedirect={!isPayLaterAllowed || isPayLaterActivated}
      fallbackRoute={ACCOUNT_ROUTES.AccountOverview.path}
    >
      <Container Tag="main" className={styles.container}>
        <HeadingLarge Tag="h1" center>
          <Label copyKey="account.signup.klarna.title" />
        </HeadingLarge>
        {storeActivationSessionStatus === LoadingStates.Loading && <Loader />}
        {storeActivationSessionStatus === LoadingStates.LoadedFail && (
          <>
            <BodyText className={styles.optinErrorMessage}>
              <Label copyKey="omnicredit.optin.error.message" />
            </BodyText>
            <Button secondary fullWidth onClick={handleLeaveStoreActivation}>
              <Label copyKey="omnicredit.optin.error.ok" />
            </Button>
          </>
        )}
        {storeActivationSessionStatus === LoadingStates.LoadedSuccess && (
          <>
            {storeActivationAuthInfo?.showForm === false ? (
              <>
                <BodyText className={styles.optinErrorMessage}>
                  <Label copyKey="omnicredit.optin.declined.message" />
                </BodyText>
                <Button secondary fullWidth onClick={handleLeaveStoreActivation}>
                  <Label copyKey="omnicredit.optin.error.ok" />
                </Button>
              </>
            ) : (
              <>
                <BodyText className={styles.infoText}>
                  <Label copyKey="omnicredit.optin.message" />
                </BodyText>
                <KlarnaPayment
                  paymentMethodCategory={storeActivationPaymentMethodCategory}
                  newSessionDetails={storeActivationSessionBody}
                  shouldLoad
                />
                <BodyText>
                  <Label copyKey="omnicredit.optin.paylater" />
                </BodyText>
                <BodyText>
                  <Label copyKey="omnicredit.optin.paylater.safety" />
                </BodyText>
                <ModalButtons fullWidth>
                  <Button
                    onClick={handleActivate}
                    shouldShowSpinner={
                      storeActivationAuthStatus === LoadingStates.Loading ||
                      storeActivationAuthInfo?.approved
                    }
                    disabled={storeActivationAuthInfo?.showForm === false}
                  >
                    <Label copyKey="omnicredit.optin.signup.confirm" />
                  </Button>
                  <Button secondary onClick={handleLeaveStoreActivation}>
                    <Label copyKey="omnicredit.optin.maybelater" />
                  </Button>
                </ModalButtons>
              </>
            )}
          </>
        )}
      </Container>
    </ConditionalRedirecter>
  )
}

export default StoreActivation
